import React from "react";
import { Image } from "react-bootstrap";

export default function Avatar({ user, size = 38 }) {
  const initials = (() => {
    const name = `${user?.first_name || ""} ${user?.last_name || ""}`.trim();
    if (!name) return "U";
    const parts = name.split(" ");
    return parts.length === 1
      ? parts[0][0].toUpperCase()
      : (parts[0][0] + parts[1][0]).toUpperCase();
  })();

  if (user?.photo) {
    return (
      <Image
        src={user.photo}
        roundedCircle
        width={size}
        height={size}
        style={{ objectFit: "cover" }}
        onError={(e) => (e.target.src = `https://ui-avatars.com/api/?name=${initials}`)}
      />
    );
  }

  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        backgroundColor: "#6c757d",
        color: "#fff",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontWeight: "bold",
      }}
    >
      {initials}
    </div>
  );
}
